import React from 'react';
import { ColumnStatus, WidgetDate, WidgetLinkTruncatedText, WidgetTime } from '../../../components';
import { sortCaret, headerSortingClasses } from '../../../helpers';
import statuses from '../../../constants/products/statuses';
import { useTranslation } from 'react-i18next';

export default function ProductsColumns () {
    const { t } = useTranslation();

    return [{
        dataField: 'id_internal_account',
        text: t('cards.table.columns.id'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        sortCaret: sortCaret,
        headerSortingClasses
    }, {
        dataField: 'id_external_account',
        text: t('cards.table.columns.gpaccount'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        sortCaret: sortCaret,
        headerSortingClasses,
    }, {
        dataField: 'created_at',
        text: t('cards.table.columns.created'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        sortCaret: sortCaret,
        headerSortingClasses,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => {
            return (
                <>
                    <WidgetDate date={new Date(cellContent)} />
                    <span> </span>
                    {(cellContent ? <WidgetTime date={new Date(cellContent)} /> : null)}
                </>
            );
        }
    }, {
        dataField: 'last_four',
        text: t('cards.table.columns.lastFour'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: (cellContent, row) => (<WidgetLinkTruncatedText to={`/clients/card/${row.id_user || ''}`} text={cellContent} truncated='false'/>)
    }, {
        dataField: 'formatted_name',
        text: t('cards.table.columns.client'),
        align: 'left',
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetLinkTruncatedText to={`/clients/details/${row.id_user || ''}`} text={cellContent || 'S/D'} truncated='false'/>)
    }, {
        dataField: 'document',
        text: t('cards.table.columns.identification'),
        align: 'left',
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetLinkTruncatedText to={`/clients/details/${row.id_user || ''}`} text={cellContent || 'S/D'} truncated='false'/>)
    },
    {
        dataField: 'id_creditcard_status',
        text: t('cards.table.columns.status'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (
            <ColumnStatus type={statuses[cellContent].type} text={t(`cards.table.status.${statuses[cellContent]?.id}`)} />
        )
    }];
}
